"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInfo = void 0;
var getClientInfo_1 = require("./getClientInfo");
Object.defineProperty(exports, "getClientInfo", { enumerable: true, get: function () { return getClientInfo_1.getClientInfo; } });
